"use strict";

exports.__esModule = true;
exports.LogbookPanelFields = void 0;
var LogbookPanelFields = exports.LogbookPanelFields = function LogbookPanelFields() {
  return null;
};